<template>
  <div
    class="main-nav"
    :class="{ sticky: !$route.path.includes('/quiet-comfort-earbud') }"
  >
    <b-navbar toggleable="lg">
      <b-navbar-brand href="/">
        <logo-bose />
      </b-navbar-brand>
      <b-navbar-toggle target="main-nav-collapse"></b-navbar-toggle>
      <b-collapse id="main-nav-collapse" class="main-links" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item
            v-for="(link, index) in mainNav"
            :key="'main-nav-link-' + index"
            :to="link.url"
            class="link"
            :class="[index === 0 ? 'active' : '']"
          >
            {{ link.name }}
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto profile-links" right>
          <b-dropdown-item href="/">
            <icon-search />
          </b-dropdown-item>
          <b-dropdown-item href="/">
            <icon-profile />
          </b-dropdown-item>
          <b-dropdown-item href="/">
            <icon-cart />
          </b-dropdown-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import LogoBose from "@/components/icons/logo-bose";
import IconProfile from "@/components/icons/icon-profile";
import IconSearch from "@/components/icons/icon-search";
import IconCart from "@/components/icons/icon-cart";
export default {
  name: "main-navigation",
  components: { IconCart, IconSearch, IconProfile, LogoBose },
  computed: {
    mainNav() {
      return this.$store.state.mainNavigation;
    },
  },
};
</script>

<style scoped lang="scss">
.theme-dark {
  .link a,
  .profile-links svg {
    color: #aaaaaa !important;
    fill: #aaaaa !important;
    &:hover {
      fill: #ffffff !important;
      color: #ffffff !important;
    }
  }
}
.theme-light {
  .link a,
  .profile-links svg {
    color: #000000 !important;
    fill: #000000;
  }
}

.main-nav {
  &:not(.products-page-nav) {
    backdrop-filter: saturate(180%) blur(20px);
    background-color: rgba(255, 255, 255, 0.9);
  }
  @media screen and (min-width: map-get($grid-breakpoints, lg)) {
    &.sticky {
      position: sticky;
      top: 0;
      z-index: 100;
    }
  }
}
.navbar {
  @media screen and (min-width: map-get($grid-breakpoints, lg)) {
    padding: 0 40px;
    height: 80px;
  }
}
.main-links {
  justify-content: center;
}
.link {
  font-size: 16px;
  padding: 9px 16px;
}
.profile-links {
  flex-direction: row;
  @media screen and (min-width: map-get($grid-breakpoints, lg)) {
    li:not(:last-child) {
      margin-right: 40px;

      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}
</style>

<style lang="scss">
@media screen and (min-width: map-get($grid-breakpoints, lg)) {
  .profile-links {
    .dropdown-item {
      padding: 0.25rem 0 !important;

      &:hover,
      &:focus {
        background: none;
      }
    }
  }
}
.navbar-light .navbar-toggler {
  border: none;
}
</style>
